export const isObjectFilled = (object: any) => Object.keys(object).length > 0;
